@if (wait.busy() || wait.visible()) {
  <div class="av-blocking-veil__visual" [class.av-blocking-veil__visual--visible]="wait.visible()">
    <av-intake-loader />
    @if (wait.patient()) {
      <p class="av-blocking-veil__still">{{ 'shared.wait.stillWorking' | translate }}</p>
    }
  </div>
}

<dialog #dialog class="av-blocking-veil__dialog" (cancel)="onDialogCancel($event)">
  <span class="visually-hidden" aria-live="polite">
    @if (wait.visible()) {
      {{ (wait.patient() ? 'shared.wait.stillWorking' : 'shared.wait.loading') | translate }}
    }
  </span>
</dialog>
